import { AnalyticService } from '../../apis/analytics';
import { FETCH_AOI_RATE_DONE } from '../mutations.type';
import { FETCH_AOI_RATE } from '../actions.type';

const initialState = {
  chartData: {
    datasets: [
      {
        data: [],
      },
    ],
  },
  options: {
    scales: {
      yAxes: [
        {
          ticks: {
            beginAtZero: true,
            stepSize: 50,
          },
        },
      ],
      xAxes: [
        {
          type: 'time',
          time: {
            displayFormats: {
              hour: 'hA',
            },
          },
          ticks: {
            maxTicksLimit: 4,
            maxRotation: 0,
            padding: 10,
            fontSize: 10,
          },
          gridLines: { display: false },
        },
      ],
    },
    legend: {
      display: false,
    },
    responsive: true,
    maintainAspectRatio: false,
  },
  aoi: 0,
  uselAoi: 0,
  onlineStoreAoi: 0,
};

export const state = { ...initialState };

export const actions = {
  async [FETCH_AOI_RATE](context, args) {
    let strStores = Array.isArray(args.stores) ? args?.stores.join(',') : args.stores;
    const { data } = await AnalyticService.fetchAverageOderItems(args.fromTime, args.toTime, strStores, args?.timezone);
    let maxValue = Math.max(...data.details.dataset);
    let stepSize = maxValue === 0 ? 20 : maxValue > 20 ? Math.round(maxValue / 4) : maxValue;
    initialState.options.scales.yAxes[0].ticks.stepSize = stepSize;
    let dataset = {
      type: 'line',
      data: data.details.dataset,
      borderColor: '#058b45',
      backgroundColor: '#eefff5',
      pointBackgroundColor: '#058b45',
      fill: true,
      pointRadius: 1,
      pointHitRadius: 1,
    };

    let rs = {
      chartData: { datasets: [dataset], labels: data.details.labels },
      options: { ...initialState.options },
      aoi: Math.round(data?.aoi * 100) / 100 || 0,
      uselAoi: Math.round(data.upsell_aoi * 100) / 100 || 0,
      onlineStoreAoi: Math.round(data?.online_store_aoi * 100) / 100 || 0,
    };
    context.commit(FETCH_AOI_RATE_DONE, rs);
    return rs;
  },
};

/* eslint no-param-reassign: ['error', { 'props': false }] */
export const mutations = {
  [FETCH_AOI_RATE_DONE](state, data) {
    state.chartData = data.chartData;
    state.options = data.options;
    state.aoi = data.aoi;
    state.uselAoi = data.uselAoi;
    state.onlineStoreAoi = data.onlineStoreAoi;
  },
};

const getters = {
  chartAoiData(state) {
    return state.chartData;
  },
  chartAoiOpts(state) {
    return state.options;
  },
  aoi(state) {
    return state.aoi;
  },
  uselAoi(state) {
    return state.uselAoi;
  },
  onlineStoreAoi(state) {
    return state.onlineStoreAoi;
  },
};

export default {
  state,
  actions,
  mutations,
  getters,
};
